import React from "react";
import
{
    Modal,
    ModalHeader,
    ModalBody,
    Button,
} from "reactstrap";
import Overview from "./components/Overview";
import Charges from "./components/Charges";
import CustomerDetails from "./components/CustomerDetails";

const stateManager = require("../../../utils/state/stateManager");
const navigationDialogueAction = require("../../../utils/state/actions/views/navigationDialogue/navigationDialogueAction");
const stringUtil = require("../../../utils/string/stringUtil");
const validator = require("../../../utils/validator/validator");
const storefrontUtils = require("../../../utils/domain/storefrontUtility");
const constants = require("../../../utils/domain/constants");
const saleInitializer = require("../../../utils/domain/sales/saleInitializer");
const saleContextUtil = require("../../Order/utils/saleContextUtil");
const translator = require('../../../utils/translator/translator');


const propertyCollectsPayment = "Property Collects Payment";
const venueCollectsPayment = "Venue Collects Payment";

class VenueDialogue extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            currentTab: "Overview",
            
            data: {
                overview: {
                    orderNumber: "",
                    dispatchType: "",
                    paymentMethod: "",
                },
                charges: {
                    serviceCharges: "",
                    deliveryCharges: "",
                    discount: "",
                },
                customerDetails: {
                    customerName: "",
                    customerPhoneNumber: "",
                    deliveryAddress: "",
                    instructions: ""
                },
            },
            error: {
                fieldName: "",
                message: ""
            }
        }


        // ref
        this.currentInputField = React.createRef(null);

        // event handlers
        this.handleCancel = this.handleCancel.bind(this);
        this.updateData = this.updateData.bind(this);
        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        // 
        this.currentStorefront = storefrontUtils.getCurrentStorefront();
        if (!this.currentStorefront.operatingConfiguration)
        {
            this.currentStorefront.operatingConfiguration = {};
        }
        this.storefrontVenueCode = storefrontUtils.getStorefrontVenueCode(this.currentStorefront);

        this.paymentMethods = [];
        this.paymentIsClearable = false;
        if (this.currentStorefront.operatingConfiguration.venueCollectsPayment && this.currentStorefront.operatingConfiguration.propertyCollectsPayment)
        {
            this.paymentMethods.push(propertyCollectsPayment);
            this.paymentMethods.push(venueCollectsPayment);
        }
        else if (this.currentStorefront.operatingConfiguration.venueCollectsPayment && !this.currentStorefront.operatingConfiguration.propertyCollectsPayment)
        {
            this.paymentMethods.push(venueCollectsPayment);
        }
        else
        {
            this.paymentMethods.push(propertyCollectsPayment);
        }

        this.state.data.overview.paymentMethod = this.paymentMethods[0];
        this.state.data.overview.dispatchType = this.props.dialoguePayload.dispatchType;
        this.paymentMethods = this.paymentMethods.map(paymentMethod => ({ label: paymentMethod, value: paymentMethod }));
    }

    validateVenueDetails()
    {
        const data = this.state.data;
        const values = { ...data.overview, ...data.charges, ...data.customerDetails };
        const error = {
            fieldName: '',
            message: '',
        }
        let tab = "";
        if (!values.orderNumber)
        {
            error.fieldName = "orderNumber";
            error.message = translator.getLabel("order_number_is_required");
            tab = "Overview";
        }
        else if (!values.dispatchType)
        {
            error.fieldName = "dispatchType";
            error.message = translator.getLabel("dispatch_type_is_required");
            tab = "Overview";
        }
        else if (!stringUtil.isStringNullOrEmpty(values.serviceCharges) && !validator.isNumeric(values.serviceCharges))
        {
            error.fieldName = "serviceCharges";
            error.message = translator.getLabel("service_charges_must_be_a_number");
            tab = "Charges";
        }
        else if (!stringUtil.isStringNullOrEmpty(values.deliveryCharges) && !validator.isNumeric(values.deliveryCharges))
        {
            error.fieldName = "deliveryCharges";
            error.message = translator.getLabel("delivery_charges_must_be_a_number");
            tab = "Charges";
        }
        else if (!stringUtil.isStringNullOrEmpty(values.discount) && !validator.isNumeric(values.discount))
        {
            error.fieldName = "discount";
            error.message = translator.getLabel("discount_charges_must_be_a_number");
            tab = "Charges";
        }

        return [values, error, tab];
    }

    handleCancel()
    {
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
    }

    handleTabSwitch(newTab)
    {
        this.setState({ currentTab: newTab }, () =>
        {
            this.currentInputField.current.focus()
        });
    }

    updateData(key1, key2, value)
    {
        this.setState(prevState =>
        {
            const clone = { ...prevState };
            clone['data'][key1][key2] = value;
            return clone;
        });
    }

    handleSubmit()
    {
        const [values, error, tab] = this.validateVenueDetails();
        this.setState({ error, currentTab: tab });
        if (error.fieldName) return;

        const sale = saleInitializer.createNewSale(this.storefrontVenueCode, values.dispatchType, this.currentStorefront.id);
        sale.number = values.orderNumber;

        if (values.paymentMethod && values.paymentMethod != propertyCollectsPayment)
        {
            sale.paymentMethod = constants.PaymentMethodVenuePaid;
        }

        if (!stringUtil.isStringNullOrEmpty(values.serviceCharges) && parseFloat(values.serviceCharges) > 0.01)
        {
            const serviceCharges = {
                type: constants.ChargesTypes.VenueServiceCharges,
                amount: parseFloat(values.serviceCharges),
                vat: 0,
                notes: null
            }
            sale.charges.push(serviceCharges);
        }

        if (!stringUtil.isStringNullOrEmpty(values.deliveryCharges) && parseFloat(values.deliveryCharges) > 0.01)
        {
            const deliveryCharges = {
                type: constants.ChargesTypes.VenueDeliveryCharges,
                amount: parseFloat(values.deliveryCharges),
                vat: 0,
                notes: null
            }
            sale.charges.push(deliveryCharges);
        }

        if (!stringUtil.isStringNullOrEmpty(values.discount) && parseFloat(values.discount) > 0.01)
        {
            const discount = {
                type: "Venue.Discount",
                value: parseFloat(values.discount),
                amount: 0,
                discountOfferType: constants.DiscountOfferTypes.Fixed,
                notes: null
            }
            sale.discounts.push(discount);
        }

        if (!stringUtil.isStringNullOrEmpty(values.customerName) ||
            !stringUtil.isStringNullOrEmpty(values.customerPhoneNumber) ||
            !stringUtil.isStringNullOrEmpty(values.deliveryAddress)
        )
        {
            const dispatchInfo = {};
            if (!stringUtil.isStringNullOrEmpty(values.customerName))
                dispatchInfo.customerName = values.customerName.trim();

            if (!stringUtil.isStringNullOrEmpty(values.customerPhoneNumber))
                dispatchInfo.customerPhoneNumber = values.customerPhoneNumber.trim()

            if (!stringUtil.isStringNullOrEmpty(values.deliveryAddress))
                dispatchInfo.deliveryAddress = values.deliveryAddress.trim()

            sale.dispatchInfo = JSON.stringify(dispatchInfo);

        }
        
        sale.instructions = values.instructions;
        const saleContext = saleContextUtil.instantiateSaleContext(sale, false);
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
        saleContextUtil.openSaleContext(saleContext);

    }

    renderTab()
    {
        switch (this.state.currentTab)
        {
            case "Charges":
                return (
                    <Charges
                        values={this.state.data.charges}
                        handleValueChange={(key2, value) => this.updateData("charges", key2, value)}
                        error={this.state.error}
                        inputFieldRef={this.currentInputField}
                    />
                )
            case "CustomerDetails":
                return (
                    <CustomerDetails
                        values={this.state.data.customerDetails}
                        handleValueChange={(key2, value) => this.updateData("customerDetails", key2, value)}
                        error={this.state.error}
                        inputFieldRef={this.currentInputField}
                    />
                );
            default:
                return (
                    <Overview
                        values={this.state.data.overview}
                        handleValueChange={(key2, value) => this.updateData("overview", key2, value)}
                        error={this.state.error}
                        paymentMethods={this.paymentMethods}
                        paymentIsClearable ={this.paymentIsClearable}
                        inputFieldRef={this.currentInputField}
                    />
                )
        }
    }

    handleModalOpen()
    {
        this.currentInputField.current.focus();
    }

    render()
    {
        return (
            <Modal isOpen={true} backdrop={true} animation={false} fade={false} size="lg" onOpened={this.handleModalOpen}>
                <ModalHeader
                    close={
                        <div>
                            <Button className="btn-cancel" onClick={this.handleCancel}>{translator.getLabel("cancel")}</Button>&nbsp;&nbsp;
                            <Button className="btn-ok" onClick={this.handleSubmit}>{translator.getLabel("done")}</Button>
                        </div>
                    }
                >
                    <span className="window-title">{translator.getLabel("venue_details")}{` - ${this.storefrontVenueCode}`}</span>
                </ModalHeader>
                <ModalBody>
                    <div className="d-flex">
                        <Button
                            onClick={() => this.handleTabSwitch("Overview")}
                            className={`btn-nav ${this.state.currentTab === "Overview" ? "selected" : ""}`}
                        >
                            {translator.getLabel("overview")}
                        </Button>
                        <Button
                            onClick={() => this.handleTabSwitch("Charges")}
                            className={`btn-nav ${this.state.currentTab === "Charges" ? "selected" : ""}`}
                        >
                            {translator.getLabel("charges")}
                        </Button>
                        <Button
                            onClick={() => this.handleTabSwitch("CustomerDetails")}
                            className={`btn-nav ${this.state.currentTab === "CustomerDetails" ? "selected" : ""}`}
                        >
                            {translator.getLabel("customer_details")}
                        </Button>
                    </div>
                    <div className="mt-4">
                        {this.renderTab()}
                    </div>
                </ModalBody>
            </Modal>
        )
    }
}

export default VenueDialogue;